var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCelebration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8825_76429",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8825_76429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.66504 44.55L13.336 17.51L30.8555 34.8295L3.66504 44.55ZM28.1965 25.8815L26.365 24.05L38.21 12.2055C39.3084 11.1068 40.7042 10.5491 42.3975 10.5325C44.0905 10.5158 45.4902 11.0568 46.5965 12.1555L47.4465 13.0055L45.6035 14.837L44.6535 13.887C44.0202 13.2536 43.2849 12.9286 42.4475 12.912C41.6102 12.8953 40.8622 13.2203 40.2035 13.887L28.1965 25.8815ZM19.9715 17.8685L18.14 16.025L19.5805 14.573C20.3552 13.8063 20.7175 12.9333 20.6675 11.954C20.6175 10.9746 20.2552 10.1476 19.5805 9.47297L18.1805 8.07297L20.024 6.24147L21.324 7.54147C22.5224 8.7478 23.1132 10.252 23.0965 12.054C23.0799 13.8556 22.4724 15.3598 21.274 16.5665L19.9715 17.8685ZM24.165 21.85L22.3215 20.0185L29.814 12.526C30.4474 11.8926 30.7557 11.0843 30.739 10.101C30.7224 9.11764 30.3974 8.3093 29.764 7.67597L26.714 4.62597L28.5575 2.78247L31.7075 5.93247C32.7729 7.03914 33.3222 8.42864 33.3555 10.101C33.3889 11.7736 32.8562 13.1591 31.7575 14.2575L24.165 21.85ZM32.34 30.075L30.4965 28.2315L32.799 25.9415C34.0054 24.7348 35.4512 24.1148 37.1365 24.0815C38.8215 24.0481 40.2674 24.6348 41.474 25.8415L44.024 28.3915L42.1805 30.235L39.5805 27.635C38.8139 26.8683 38.0139 26.485 37.1805 26.485C36.3472 26.485 35.5472 26.8683 34.7805 27.635L32.34 30.075Z",
    fill: "#5D8CEC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCelebration);
export default __webpack_public_path__ + "static/media/celebration.b9ea664a7f55ce141a3bd2a34555e734.svg";
export { ForwardRef as ReactComponent };